class TabSlider {
    constructor(options) {
        this.options = {
            container: '', // 整体容器
            tabItemSelector: '', // tab项选择器
            contentSelector: '', // 内容项选择器
            scrollContainer: '', // 可滚动容器
            prevButton: '', // 上一个按钮
            nextButton: '', // 下一个按钮
            activeClass: 'current', // 激活状态类名
            contentActiveClass: 'active', // 内容激活状态类名
            ...options
        };

        this.init();
    }

    init() {
        // 初始化swiper
        this.swiper = new Swiper(this.options.container, {
            slidesPerView: 1,
            spaceBetween: 10,
            watchOverflow: false,
            navigation: {
                nextEl: this.options.nextButton,
                prevEl: this.options.prevButton
            }
        });

        // 初始化tab点击事件
        this.tabItems = document.querySelectorAll(this.options.tabItemSelector);
        this.tabItems.forEach((item, index) => {
            item.addEventListener('click', () => this.switchTab(index));
        });

        // 初始化内容项
        this.contentItems = document.querySelectorAll(this.options.contentSelector);

        // 监听滑动变化
        this.swiper.on('slideChange', () => this.handleSlideChange());

        // 初始化滚动按钮
        if (this.options.prevButton && this.options.nextButton) {
            document.querySelector(this.options.prevButton).addEventListener('click', () => this.scroll('left'));
            document.querySelector(this.options.nextButton).addEventListener('click', () => this.scroll('right'));
        }
    }

    switchTab(index) {
        this.tabItems.forEach(t => t.classList.remove(this.options.activeClass));
        this.tabItems[index].classList.add(this.options.activeClass);
        this.swiper.slideTo(index);
    }

    handleSlideChange() {
        const activeIndex = this.swiper.activeIndex;

        // 更新内容激活状态
        this.contentItems.forEach(t => t.classList.remove(this.options.contentActiveClass));
        this.contentItems[activeIndex].classList.add(this.options.contentActiveClass);

        // 更新tab激活状态
        this.tabItems.forEach(t => t.classList.remove(this.options.activeClass));
        this.tabItems[activeIndex].classList.add(this.options.activeClass);

        // 滚动到当前激活的tab
        if (this.options.scrollContainer) {
            console.log(this.tabItems[activeIndex].offsetLeft);
            document.querySelector(this.options.scrollContainer).scrollTo({
                left: this.tabItems[activeIndex].offsetLeft,
                behavior: 'smooth'
            });
        }
    }

    scroll(direction) {
        if (!this.options.scrollContainer) return;
        // 计算this.tabItems[activeIndex]的宽度与屏幕宽度比
        const activeTab = this.tabItems[this.swiper.activeIndex].offsetWidth;
        const screenWidth = window.innerWidth;
        const b = activeTab / screenWidth;
        const scrollAmount = direction === 'left' ? -window.innerWidth * b : window.innerWidth * b;
        document.querySelector(this.options.scrollContainer).scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth <= 768) {
        const safetySwiper = new Swiper('.safety-swiper', {
            slidesPerView: 1,
            spaceBetween: 20,
            pagination: {
                el: '.safety-swiper .swiper-pagination',
                clickable: true
            }
        });
    }

    // video slider
    const videoSlider = new TabSlider({
        container: '.section-video .video-content-container',
        tabItemSelector: '.section-video .video-class-item-container .video-class-item',
        contentSelector: '.section-video .video-content-container .video-content',
        scrollContainer: '.video-class-item-container',
        prevButton: '.section-video .video-class-container .fa-angle-left',
        nextButton: '.section-video .video-class-container .fa-angle-right',
    });
    const section_3_1_slider = new TabSlider({
        container: '.section-3-1 .section-3-1-content-swiper-wrapper',
        tabItemSelector: '.section-3-1 .section-3-1-class-container .section-3-1-class-item',
        contentSelector: '.section-3-1 .section-3-1-content-item',
        scrollContainer: '.section-3-1-class-container',
        prevButton: '.section-3-1 .section-3-1-class-container-wrapper .fa-angle-left',
        nextButton: '.section-3-1 .section-3-1-class-container-wrapper .fa-angle-right',
    });

    const case_content_swiper1 = new TabSlider({
        container: '.case-content.case-content-swiper1',
        tabItemSelector: '.case-content.case-content-swiper1 .case-content-item-class-item',
        contentSelector: '.case-content.case-content-swiper1 .case-content-item',
        scrollContainer: '.case-content.case-content-swiper1 .case-content-item-class-container .case-content-item-class',
        prevButton: '.case-content.case-content-swiper1 .case-content-item-class-container i.fa-angle-left',
        nextButton: '.case-content.case-content-swiper1 .case-content-item-class-container i.fa-angle-right',
    });

    const case_content_swiper2 = new TabSlider({
        container: '.case-content.case-content-swiper2',
        tabItemSelector: '.case-content.case-content-swiper2 .case-content-item-class-item',
        contentSelector: '.case-content.case-content-swiper2 .case-content-item',
        scrollContainer: '.case-content.case-content-swiper2 .case-content-item-class-container .case-content-item-class',
        prevButton: '.case-content.case-content-swiper2 .case-content-item-class-container i.fa-angle-left',
        nextButton: '.case-content.case-content-swiper2 .case-content-item-class-container i.fa-angle-right',
    });
    

    // banner 视频弹窗
    // 选择 video-popup-play 和 video-popup-content
    const videoPlayButton = document.querySelector('.video-popup-play');
    const videoPopupContent = document.querySelector('.video-popup-content');
    const videoOverlay = document.createElement('div');
    videoOverlay.className = 'video-popup-overlay';
    document.body.appendChild(videoOverlay);

    // 点击播放按钮时显示视频弹窗
    videoPlayButton.addEventListener('click', function () {
        videoPopupContent.classList.add('active');
        videoOverlay.classList.add('active');
        const iframe = document.getElementById('youtube-video');
        const src = iframe.src;
        iframe.src = src + "&autoplay=1"; // 自动播放视频
    });

    // 点击遮罩层或视频弹窗外部时关闭视频弹窗
    videoOverlay.addEventListener('click', function () {
        videoPopupContent.classList.remove('active');
        videoOverlay.classList.remove('active');
        const iframe = document.getElementById('youtube-video');
        const src = iframe.src;
        iframe.src = src.replace("&autoplay=1", ""); // 停止播放视频
    });

    // 控制section-4-tools-content-right-item的显示
    // 获取所有右侧item元素
    const toolsRightItems = document.querySelectorAll('.section-4-tools-content-right-item');
    // 获取所有左侧item元素
    const toolsLeftItems = document.querySelectorAll('.section-4-tools-content-left-item');

    // 为每个右侧item添加点击事件
    toolsRightItems.forEach((item, index) => {
        item.addEventListener('click', function() {
            // 移除所有左侧item的active类
            toolsLeftItems.forEach(leftItem => {
                leftItem.classList.remove('active');
            });
            // 为对应的左侧item添加active类
            if (toolsLeftItems[index]) {
                toolsLeftItems[index].classList.add('active');
            }
        });
    });

    // 控制case-class的显示
    // 获取所有相关元素
    const caseTabs = document.querySelectorAll('.case-class p');
    const caseContents = document.querySelectorAll('.case-content');
    
    // 初始化显示状态
    caseContents[0].style.display = 'block';
    caseContents[1].style.display = 'none';
    
    // 为每个tab添加点击事件
    caseTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
            // 移除所有active类
            caseTabs.forEach(t => t.classList.remove('case-class-active'));
            // 添加当前active类
            tab.classList.add('case-class-active');
            
            // 隐藏所有内容
            caseContents.forEach(content => {
                content.style.display = 'none';
            });
            // 显示当前内容
            caseContents[index].style.display = 'block';
        });
    });

    // 控制faq-content-item的显示
    const faqItems = document.querySelectorAll('.section-4-faq-content-item');
    faqItems.forEach(item => {
        item.addEventListener('click', () => {
            item.classList.toggle('active');
        });
    });
  (function ($) {
    $.fn.lazyVideo = function () {
      const videos = this;
  
      function loadVideo($video) {
        const $source = $video.find('source');
  
        $source.each(function () {
          const $src = $(this).attr('data-src');
          if ($src) {
            $(this).attr('src', $src).removeAttr('data-src');
          }
        });
  
        $video[0].load();
      }
  
      function isInViewport(el) {
        const rect = el.getBoundingClientRect();
        return rect.top < window.innerHeight && rect.bottom > 0;
      }
  
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              const $video = $(entry.target);
              loadVideo($video);
              observer.unobserve(entry.target);
            }
          });
        });
  
        videos.each(function () {
          observer.observe(this);
        });
      } else {
        // fallback for older browsers
        function checkAllVideos() {
          videos.each(function () {
            const $video = $(this);
            if ($video.find('source[data-src]').length && isInViewport(this)) {
              loadVideo($video);
            }
          });
        }
  
        $(window).on('scroll resize load', checkAllVideos);
        checkAllVideos(); // initial check
      }
  
      return this; // 支持链式调用
    };
  })(jQuery);

  $('.lazy-video').lazyVideo();
});
